/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `Dart Due Date Bot` - DART_DUE_DATE_BOT
 * * `Dart GitHub Bot` - DART_GITHUB_BOT
 * * `Dart Metrics Bot` - DART_METRICS_BOT
 * * `Dart Automation` - DART_AUTOMATION
 * * `Dart Recurring Task Bot` - DART_RECURRING_TASK_BOT
 * * `Dart Reminder Bot` - DART_REMINDER_BOT
 * * `Dart Slack Bot` - DART_SLACK_BOT
 * * `Dart Sprint Bot` - DART_SPRINT_BOT
 * * `A form user` - FORM_USER
 * * `An email user` - EMAIL_USER
 * * `Stripe webhook` - STRIPE_WEBHOOK
 */
export enum EventActor {
  DART_DUE_DATE_BOT = 'Dart Due Date Bot',
  DART_GITHUB_BOT = 'Dart GitHub Bot',
  DART_METRICS_BOT = 'Dart Metrics Bot',
  DART_AUTOMATION = 'Dart Automation',
  DART_RECURRING_TASK_BOT = 'Dart Recurring Task Bot',
  DART_REMINDER_BOT = 'Dart Reminder Bot',
  DART_SLACK_BOT = 'Dart Slack Bot',
  DART_SPRINT_BOT = 'Dart Sprint Bot',
  FORM_USER = 'A form user',
  EMAIL_USER = 'An email user',
  STRIPE_WEBHOOK = 'Stripe webhook',
}
